import React from "react";
import './SellCarPage.css';

function SellCarPage() {
  return (
    <section className="sell-car">
      <div className="container">
        <h2>Sell Your Car in Simple Steps</h2>
        <div className="steps">
          <div className="step">
            <i className="icon">📄</i>
            <p>Post your car details</p>
          </div>
          <div className="step">
            <i className="icon">💰</i>
            <p>Get the best price for your car</p>
          </div>
          <div className="step">
            <i className="icon">🚗</i>
            <p>Get paid in 48 hours</p>
          </div>
        </div>
        <form className="car-details-form">
          <h3>Enter your car details</h3>
          <label>Year:</label>
          <select required>
            <option value="">Select</option>
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
            <option value="2021">2020</option>
            <option value="2021">2019</option>
            <option value="2021">2018</option>
            <option value="2021">2017</option>
            <option value="2021">2016</option>
            <option value="2021">2015</option>
            <option value="2021">2014</option>
            <option value="2021">2013</option>
            <option value="2021">2012</option>
            <option value="2021">2011</option>
            <option value="2021">2010</option>
            <option value="2021">2009</option>
            <option value="2021">2008</option>
            <option value="2021">2007</option>
            <option value="2021">2006</option>
            {/* Add more options as needed */}
          </select>
          <label>Make:</label>
          <input type="text" placeholder="Enter car make" required />
          <label>Model:</label>
          <input type="text" placeholder="Enter car model" required />
          <label>Upload Image:</label>
          <input type="file" />
          <button type="submit" className="submit-btn">
            Next
          </button>
        </form>
      </div>
    </section>
  );
}

export default SellCarPage;
